import { typesLang } from '../@types/shared/types';
import { getQueryParam } from './general';

export const sharedUtilsGetLang = (): typesLang => {
  // from path url or locale param
  let lang: typesLang = 'nl';
  if (window.location.pathname.includes('/en/')) {
    lang = 'en';
  }
  const paramLang = getQueryParam('lang');
  if (paramLang) {
    lang = paramLang as typesLang;
  }

  // console.log('sharedUtilsGetLang', lang);

  return lang;
};
